<template>
  <!--  <div class="container">-->
  <div class="container">
    <header class="text-center mb-5">
      <HeadComponent/>
      <h1 class="display-4 fw-bold">LinkCurt</h1>
      <p class="lead">Shorten, share, and manage your links easily.</p>
    </header>

    <section>
      <h2 class="text-center text-secondary mb-4">Why use LinkCurt?</h2>
      <div class="row justify-content-center">
        <div class="col-12 col-md-6">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">🔗 Shorten unlimited links</li>
            <li class="list-group-item">📊 Click statistics</li>
            <li class="list-group-item">🔒 Safe and private</li>
            <li class="list-group-item">🖼️ Generate QR codes</li>
          </ul>
        </div>
      </div>
    </section>
  </div>
  <FooterComponent/>
  <!--  </div>-->
</template>

<script>
import HeadComponent from "@/components/views/head/HeadComponent.vue";
import FooterComponent from "@/components/views/footer/FooterComponent.vue";

export default {
  name: "LandingPage",
  /**
   * Defines the components of the application.
   *
   * @property {Object} components - An object containing the components used in the application.
   * @property {Object} components.HeadComponent - The component responsible for rendering the header of the application.
   * @property {Object} components.FooterComponent - The component responsible for rendering the footer of the application.
   */
  components: {
    HeadComponent,
    FooterComponent,
  },
};
</script>

<style scoped>
h1 {
  color: #18629F;
}
</style>
